import { pathToUrl } from '../../helpers/urls';

export interface Reef {
  image_url: string;
  description: string;
  type: string;
  id: string;
  longitude: number;
  structure: string;
  link_url: string;
  latitude: number;
  deploymentdate: string;
  region: string;
  depth_ft: number;
  name: string;
}

interface Result {
  success: boolean;
  results: Reef;
}

export async function getReefById(
  { fishrulesReefId }: { fishrulesReefId: number },
  signal: AbortSignal,
): Promise<Result> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-reef-by-id'), {
    body: JSON.stringify({ fishrulesReefId }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: Result = await response.json();
  return json;
}
